import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { Caption1 } from '../styled/typography/typography'

export default class ContentWarning extends Component {
  render () {
    const { text, abbrev } = this.props
    return (
      <Caption1
        className='content-warning'
        data-tip={text}
        data-for={`content-warning-${abbrev}`}>
        <div className='abbrev'>{abbrev}</div>
        <ReactTooltip
          id={`content-warning-${abbrev}`}
          effect='solid' />
      </Caption1>
    )
  }
}

ContentWarning.propTypes = {
  text: PropTypes.string,
  abbrev: PropTypes.string
}
